module.exports = __webpack_public_path__ + "img/Profil_VP-Lite_Alu.87dcad7f.jpg";